'use strict'
import React from 'react'
import PropTypes from 'prop-types'
import { withCookies, Cookies } from 'react-cookie'

class Variant extends React.Component {
  render () {
    const { children, cookies, showByDefault, name } = this.props
    const { getExperimentName, getValidVariants } = this.context
    const cookie = cookies.get(getExperimentName)
    const Wrapper = this.props.childrenWrapper
    const display = (cookie === name) || (!getValidVariants.includes(cookie) && showByDefault)

    return display && (
      <Wrapper>{children}</Wrapper>
    )
  }
}

Variant.defaultProps = {
  type: 'variant',
  childrenWrapper: 'div',
  showByDefault: false
}

Variant.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  childrenWrapper: PropTypes.node,
  children: PropTypes.node,
  showByDefault: PropTypes.bool.isRequired
}

Variant.contextTypes = {
  getExperimentName: PropTypes.string,
  getValidVariants: PropTypes.array
}

export default withCookies(Variant)
